import { render, staticRenderFns } from "./FillingDetailsSummaryFields.vue?vue&type=template&id=0705382a"
import script from "./FillingDetailsSummaryFields.vue?vue&type=script&lang=js"
export * from "./FillingDetailsSummaryFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports